import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B090016FindRequest = {
  sokoCd: string;
  shohinCd: string;
  locationCd: string;
} & Partial<{
  page: number;
  sort: string[];
  size: number;
}>;

export type B090016FindResponse = {
  juchudenpyoNo: string;
  hachudenpyoNo: string;
  shireCd: string;
  shireNmr: string;
  hachusu: string;
  shirezumisu: string;
  nyukayoteisu: string;
  nyukayoteiYmd: string;
};

//検索処理
export const B090016Find = (props: B090016FindRequest) => {
  return RestClient.get<PageableResponse<B090016FindResponse[]>>(
    "b090016/find",
    {
      params: props,
    }
  );
};
